exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myred{background-color:#e21713!important;border-color:#e21713!important}.myyell{background-color:#ff0!important;border-color:#ff0!important;color:#000!important}.mygreen{background-color:#006400!important;border-color:#006400!important}.myorange{background-color:#ff8c00!important;border-color:#ff8c00!important}.theme--light.v-btn--active:before,.theme--light.v-btn--active:hover:before{opacity:0}.theme--light.v-btn:hover:before{opacity:.08}", ""]);

// exports
